import React from "react";
import { Image, Dropdown, Row, Col } from "react-bootstrap";
import { getCategoryNameFromId, getWeightText } from "../helper";
import AWS_CONSTANTS from "../constants/aws";
import { FaTrashAlt } from "react-icons/fa";
import SelectableContext from "react-bootstrap/SelectableContext";

export const getImagePreview = (imageFile, image_src, updateImage) => {
  if (imageFile !== null) {
    return (
      <Image
        style={{ border: "5px solid black" }}
        className="h-100 w-100"
        src={URL.createObjectURL(imageFile)}
      />
    );
  } else if (image_src != null) {
    return (
      <Image
        key={Date.now()}
        style={{ border: "5px solid black" }}
        className="h-100 w-100"
        src={
          AWS_CONSTANTS.ASSETS_URL +
          image_src +
          `?${updateImage ? Date.now() : ""}`
        }
      />
    );
  }
};

export const allPackaging = (handleOnClick) => (
  <SelectableContext.Provider value={false}>
    <Dropdown>
      <Dropdown.Toggle>{"Choose A Packaging "}</Dropdown.Toggle>
      <Dropdown.Menu>
        {[100, 250, 500, 750, 1000, 2000].map((element, index) => (
          <Dropdown.Item
            key={element + "-" + index}
            eventKey={element}
            onClick={() => handleOnClick(element)}
          >
            {getWeightText(element)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </SelectableContext.Provider>
);

export const productPackagingDropDown = (productPackaging, handleOnDelete) => {
  return productPackaging && productPackaging.length > 0 ? (
    <SelectableContext.Provider value={false}>
      <Dropdown>
        <Dropdown.Toggle>Product Packaging</Dropdown.Toggle>
        <Dropdown.Menu>
          {productPackaging.map((element, index) => (
            <Dropdown.Item key={element + "-" + index} eventKey={element}>
              <Row>
                <Col>{getWeightText(element)}</Col>
                <Col>
                  <FaTrashAlt
                    className="ml-1"
                    size={20}
                    onClick={() => handleOnDelete(element)}
                  />
                </Col>
              </Row>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </SelectableContext.Provider>
  ) : (
    "No Product Packing"
  );
};

export const defaultProductPackaging = (
  defaultPackaging,
  productPackaging,
  handleOnClick
) =>
  productPackaging && productPackaging.length > 0 ? (
    <SelectableContext.Provider value={false}>
      <Dropdown>
        <Dropdown.Toggle>
          {defaultPackaging
            ? getWeightText(defaultPackaging)
            : "Choose a default packaging"}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {productPackaging.length > 0 && (
            <Dropdown.Item
              key="default-packaging-null"
              eventKey="default-packaging-null"
              onClick={() => handleOnClick(null)}
            >
              None
            </Dropdown.Item>
          )}
          {productPackaging.map((element, index) => (
            <Dropdown.Item
              key={element + "-" + index}
              eventKey={element}
              onClick={() => handleOnClick(element)}
            >
              {getWeightText(element)}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </SelectableContext.Provider>
  ) : (
    "Select Product Packaging First"
  );

export const getCategoriesView = (
  categories,
  categoriesColumnFn,
  handleOnClick,
  rowAttributes
) => {
  const { xs, sm, md, lg } = rowAttributes;
  let retval = [];
  const numColsPerRow = 4;
  let numCells = categories.length;
  const numRows = Number(Math.ceil(categories.length / numColsPerRow));
  for (var i = 0; i < numRows; i += 1) {
    if (numCells > numColsPerRow) {
      retval.push(
        <Row sm={sm} md={md} lg={lg} xs={xs} key={i}>
          {categoriesColumnFn(
            categories,
            i * numColsPerRow,
            i * numColsPerRow + (numColsPerRow - 1),
            handleOnClick
          )}
        </Row>
      );
      numCells -= numColsPerRow;
    } else if (numCells <= numColsPerRow) {
      retval.push(
        <Row md={md} sm={sm} lg={lg} xs={xs} key={i}>
          {categoriesColumnFn(
            categories,
            i * numColsPerRow,
            i * numColsPerRow + (numCells - 1),
            handleOnClick
          )}
        </Row>
      );
    }
  }
  return retval;
};

export const getCategoryDropdown = (categories, categoryId, handleOnClick) => (
  <SelectableContext.Provider value={false}>
    <Dropdown>
      <Dropdown.Toggle>
        {categoryId
          ? getCategoryNameFromId(categories, categoryId)
          : "Choose Category"}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {categories.map((element) => (
          <Dropdown.Item
            key={element.category_id}
            eventKey={element.category_id}
            onClick={() => handleOnClick(element)}
            id={element.category_id}
            active={categoryId === element.category_id}
          >
            {element.category_name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </SelectableContext.Provider>
);

export const getSubCategoryDropDown = (
  subCateogories,
  subCategory,
  handleOnClick
) => (
  <SelectableContext.Provider value={false}>
    <Dropdown>
      <Dropdown.Toggle>{subCategory}</Dropdown.Toggle>
      <Dropdown.Menu>
        {subCateogories.map((element) => (
          <Dropdown.Item
            key={element}
            eventKey={element}
            onClick={() => handleOnClick(element)}
            id={element}
            active={subCategory === element}
          >
            {element}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </SelectableContext.Provider>
);

export const filterByOrderStatusDropdown = (status, handleOnClick) => (
  <Dropdown>
    <Dropdown.Toggle>{status ? status : "Filter By Status"}</Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item
        key="None-0"
        eventKey="None"
        onClick={() => handleOnClick(null)}
        active={null === status}
      >
        None
      </Dropdown.Item>
      {[
        "Received",
        "Delivered",
        "Cancelled",
        "Dispatched",
        "Payment Incomplete",
        "Packed",
        "Refunded",
        "Failed",
      ].map((element, index) => (
        <Dropdown.Item
          key={element + "-" + index + 1}
          eventKey={element}
          onClick={() => handleOnClick(element)}
          active={element === status}
        >
          {element}
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);
